import type { HustroDbEntityTablesUnion } from 'serviceWorker/db';

/**
 * The API no longer knows the sync key of a collection. Expected, not a
 * defect: the collection was cleared with its state and is downloaded again
 * in full, whose own failure is the one to report.
 */
export class InvalidSyncKeyError extends Error {
  constructor(readonly table: HustroDbEntityTablesUnion) {
    super(`Invalid sync key on GET ${table}`);
    this.name = 'InvalidSyncKeyError';
  }
}

export function isInvalidSyncKeyError(error: unknown): error is InvalidSyncKeyError {
  return error instanceof InvalidSyncKeyError;
}
